'use client';

import { FC, useEffect } from 'react';

import { LangType } from '@/app/[lang]/_type/lang';

import useSeenListing from '../_hooks/useSeenListing';

export interface SeenListingProps {
    lang: LangType;
    originIds: string[];
}

const SeenListing: FC<SeenListingProps> = ({ originIds }) => {
    const { postSeenListing } = useSeenListing();

    useEffect(() => {
        if (originIds.length < 1) return;
        postSeenListing(originIds);

        // Check if we're in the browser environment
        if (typeof window === 'undefined' || !window.localStorage) return;

        try {
            const originId = (originIds || [])[0];
            const lastVisitLog = localStorage.getItem('last-visit-log');
            const parseJsonLogs: any[] = JSON.parse(lastVisitLog || '{}') || [];

            const filterLastVisitLog = parseJsonLogs.filter(
                (log) => log.originId === originId,
            );
            const count = filterLastVisitLog.length;

            const storageKey = 'save-nudges';
            const raw = localStorage.getItem(storageKey);
            const visits = raw ? Number(raw) : 0;

            if (visits > 2) return;

            if (visits === 0 && count === 1) {
                localStorage.setItem(storageKey, '1');
            } else if (visits === 1 && count === 2) {
                localStorage.setItem(storageKey, '2');
            }
        } catch (error) {
            console.error('[Local Storage Last Visit]', error);
        }
    }, []);

    return <></>;
};

export default SeenListing;
